var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    enableBackground: "new 0 0 42 42",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.5,32.344c-1.5,0.381-2.428,0.017-3.261-1.233l-5.921-8.192l-0.856-1.134l-6.915,9.353 c-0.79,1.125-1.619,1.615-3.093,1.217l8.854-11.886L22.065,9.732c1.418-0.276,2.397-0.135,3.267,1.134l6.141,8.294l6.187-8.249 c0.792-1.125,1.645-1.553,3.068-1.138l-3.196,4.238l-4.331,5.639c-0.516,0.644-0.445,1.085,0.03,1.707L41.5,32.344z M0.991,16.707 c1.972-7.05,10.053-9.98,15.626-5.624c3.257,2.562,4.066,6.187,3.905,10.246H2.164c-0.276,7.308,4.984,11.718,11.69,9.468 c2.352-0.79,3.738-2.632,4.431-4.936c0.352-1.155,0.934-1.335,2.02-1.005c-0.554,2.882-1.804,5.289-4.447,6.796 c-3.948,2.255-9.583,1.526-12.547-1.609C-1.088,24.521,0.991,16.707,0.991,16.707z M2.197,19.78h16.59 c-0.108-5.284-3.399-9.038-7.896-9.069C5.956,10.672,2.411,14.336,2.197,19.78L2.197,19.78L2.197,19.78z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB3);
export default __webpack_public_path__ + "static/media/b3.b11d87b375df7a787920a50d1e31b705.svg";
export { ForwardRef as ReactComponent };